module.exports = __webpack_public_path__ + "6bbad91dc564bf631112e91ad21e5690.png";